export default __webpack_public_path__ + "static/desk-property01-0b616f6864b4a39b1bcacb950bb63796.jpg";